import * as ActionTypes from '../actions/index';
import {fromJS} from "immutable";
import {createReducer} from "./index";

const INITIAL_STATE = fromJS({
  all: null,
  toEdit: null,
});

function setRelatedProducts(state, action) {
  return state
    .set('all', fromJS(action.payload))
}

function setRelatedProductsEdit(state, action) {
  return state
    .set('toEdit', fromJS(action.payload))
}

function clearRelatedProducts() {
  return INITIAL_STATE;
}

function storeEditedRelatedProducts(state, action) {
  if (!action.payload.relatedProducts || !action.payload.relatedProducts.length) return state;
  const toEdit = action.payload.relatedProducts.map(prod => {
      return {
        value: prod.secondProductId,
        label: undefined,
      }
  });
  return state.set('toEdit', fromJS(toEdit));
}

export const relatedProducts = createReducer(INITIAL_STATE, {
  [ActionTypes.SET_RELATED_PRODUCTS]: setRelatedProducts,
  [ActionTypes.SET_RELATED_PRODUCTS_EDIT]: setRelatedProductsEdit,
  [ActionTypes.CLEAR_RELATED_PRODUCTS]: clearRelatedProducts,
  [ActionTypes.RECEIVE_PRODUCT_BY_ID]: storeEditedRelatedProducts,
});



// WEBPACK FOOTER //
// ./src/reducers/relatedProducts.js